<!-- https://odilotid.atlassian.net/browse/ORN-5181
    Chromium ignores autocomplete="off" on inputs but respects it at <form> level.
    ngNoForm prevents Angular from creating NgForm (would require [name] on inner ngModel).
    role="search" marks this as a search landmark for screen readers.
    See: https://issues.chromium.org/issues/40093420 -->
<form autocomplete="off" role="search" ngNoForm (submit)="onSubmit($event)">
  <opac-text-input
    [icon]="inputIcon()"
    [ngModel]="internalValue()"
    (iconClick)="handleIconClick()"
    (input)="updateInternalValue($event)"
    (ngModelChange)="onValueChanges($event)">
    <ng-content></ng-content>
  </opac-text-input>
</form>
